import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Space } from 'antd';
import classNames from 'classnames';

import { GET_PRODUCTS_IMPORT_TEMPLATE_ENDPOINT } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import { useProductsHeader } from '@app/pages/Warehouses/Products/hooks';
import { openImportTemplateFile } from '@app/utils';

import { ProductsImport } from './ProductsImport';

import type { MenuProps } from 'antd';
import type { FC } from 'react';

export const ProductsHeader: FC = () => {
  const {
    goToAddProduct,
    IsProductCreate,
    IsExportWarehouseProductsToExcel,
    exportWarehouseProductsToExcelHandler,
    isExportLoading,
  } = useProductsHeader();
  const { isMobile } = useWindowSize();

  const excelItems: MenuProps['items'] = [
    ...(IsExportWarehouseProductsToExcel
      ? [
          {
            key: 'export-products',
            label: (
              <span
                onClick={exportWarehouseProductsToExcelHandler}
                data-testid="export-to-excel"
              >
                Выгрузить в Excel
              </span>
            ),
          },
        ]
      : []),
    ...(IsProductCreate
      ? [
          {
            key: 'export-products-template',
            label: (
              <span
                onClick={() =>
                  openImportTemplateFile(GET_PRODUCTS_IMPORT_TEMPLATE_ENDPOINT)
                }
                className="unselectable"
                data-testid="export-products-template"
              >
                Выгрузить шаблон создания товаров
              </span>
            ),
          },
        ]
      : []),
    ...(IsProductCreate
      ? [
          {
            key: 'import-products',
            label: <ProductsImport />,
          },
        ]
      : []),
  ];

  if (!IsProductCreate && !IsExportWarehouseProductsToExcel) {
    return null;
  }

  return (
    <Space>
      {(IsExportWarehouseProductsToExcel || IsProductCreate) && (
        <Dropdown menu={{ items: excelItems }} placement="bottomRight">
          <Button
            loading={isExportLoading}
            disabled={isExportLoading}
            data-testid="excel-operations"
          >
            <Space>
              {isMobile ? (
                <FontAwesomeIcon icon={faFileExcel} size={'lg'} />
              ) : (
                <>
                  Операции с Excel
                  <DownOutlined />
                </>
              )}
            </Space>
          </Button>
        </Dropdown>
      )}

      {IsProductCreate && (
        <Button
          className={classNames({ 'full-width': isMobile })}
          type="primary"
          onClick={goToAddProduct}
          icon={<PlusOutlined />}
        >
          Добавить товар
        </Button>
      )}
    </Space>
  );
};
